<template>
  <div class="toggle-block__details w-100 ml-5">
    <div class="toggle-block__details-head flex-column" v-if="FBM.data.shippingPartnerType !== null">
      <div class="toggle-block__details-title">
        <img v-if="FBM.data.shippingPartnerType.logo_base64" height="22" :src="FBM.data.shippingPartnerType.logo_base64" alt="ico">
        <img v-else-if="FBM.data.shippingPartnerType.logo" height="22" :src="FBM.data.shippingPartnerType.logo" alt="ico">
      </div>
    </div>
    <div class="toggle-block__details-body" v-if="FBM.data.shippingPartnerType !== null">
      <div class="custom-row" v-if="FBM.data.shippingAPIPrices && Object.keys(FBM.data.shippingAPIPrices).length">
        <div class="custom-col flex-column-reverse mb-2"
             v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
          <div class="admin-edit" @click="editTranslate(['fbm_Includes','fbm_Duty', ])"></div>
          <RadioDefault
              class="mb-2"
              :class="{'mb-4' : Number(itemShippingAPIPrices.duty_value) > 0 || Number(itemShippingAPIPrices.vat_value) > 0}"
              name="fedexRadioListRate"
              v-for="(itemShippingAPIPrices, index) in FBM.data.shippingAPIPrices"
              :key="index + 'shippingPrice'"
              :label="shippingPriceRadioLabel(itemShippingAPIPrices)"
              :value="FBM.data.shippingAPIPrice && FBM.data.shippingAPIPrice.driver_delivery_method_id === itemShippingAPIPrices.driver_delivery_method_id"
              :disabled="!isLabel && !isAdmin"
              :helpText="getDutyAndVat(itemShippingAPIPrices)"
              @click.native="$emit('changeShippingAPIPrices', itemShippingAPIPrices)"
          />
        </div>

        <template v-if="isLabel || isAdminManage">
          <template v-if="_.has(FBM.data.shippingPartnerType, 'signature_price') && getShippingPartner['shipping_methods'].length === 1">

            <div class="custom-col mb-2"
                 v-if=" FBM.data.shippingPartnerType.signature_price && FBM.data.shippingPartner.can_requaire_signature"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate([
                        'fbm_TheSignFromRecepient',
                        'fbm_ServiceFee',
                        'fbm_ViewPrices'
                        ])"></div>
              <DefaultCheckbox
                  class="bold"
                  :label="$t('fbm_TheSignFromRecepient.localization_value.value')"
                  :value="FBM.data.signFromRecipient"
                  @input="val => $emit('changeSignFromRecipient', val)"
              />
              <div class="amount-row light pl-4 mt-2" v-if="Number(FBM.data.shippingPartnerType.signature_price) > 0">
                <template v-if="FBM.data.shippingPartnerType.delivery_service_code === FBM_SHIPPING_TYPES.FBM_SHIPPING_FEDEX.delivery_service_code">
                  {{$t('fbm_ServiceFeeFedex.localization_value.value')}}
                </template>
                <template v-else-if="FBM.data.shippingPartnerType.delivery_service_code === FBM_SHIPPING_TYPES.FBM_SHIPPING_USPS.delivery_service_code">
                  {{$t('fbm_ServiceFeeUsps.localization_value.value')}}
                </template>
                <template v-else>
                  {{$t('fbm_ServiceFee.localization_value.value')}}
                </template>

                <!--                        <span class="ml-1">-->
                <!--                          ${{FBM.data.shippingPartnerType.signature_price}}-->
                <!--                        </span>-->
              </div>
            </div>

            <div class="custom-col mb-2"
                 v-if="FBM.data.shippingPartner.possible_saturday_delivery"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['fbm_PossibleSaturdayDelivery',])"></div>
              <DefaultCheckbox
                  class="bold"
                  :label="$t('fbm_PossibleSaturdayDelivery.localization_value.value')"
                  v-model="FBM.data.possibleSaturdayDelivery"
                  @changeCheckbox="$emit('calculatePriceUser')"
              />
            </div>

            <div class="custom-col mb-0"
                 v-if="isAdminManage"
            >
              <div style="justify-content: flex-start;" class="toggle-block__details-bottom"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['fbm_CalculatePrice', 'fbm_reCreateLabel'])"></div>
                <MainButton
                    class="wfc mr-3"
                    :value="$t('fbm_CalculatePrice.localization_value.value')"
                    @click.native="$emit('calculatePriceAdmin')"
                />
                <MainButton
                    v-if="isAdminManage && FBM.data.Order.data.fileLabel"
                    class="wfc"
                    :value="$t('fbm_reCreateLabel.localization_value.value')"
                    @click.native="$emit('reCreateLabel')"
                    v-bind:class="{'disabled-btn' : $store.getters.getOrdersFBMBtn}"
                />
              </div>
            </div>

          </template>
        </template>



      </div>

      <div class="custom-row" v-if="FBM.data.shippingAPIPrices && Object.keys(FBM.data.shippingAPIPrices).length === 0">
        <div class="custom-col">
          <div v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
            <div class="admin-edit" @click="editTranslate(['fbm_NoPricesAvailable'])"></div>
            {{$t('fbm_NoPricesAvailable.localization_value.value')}}
          </div>
          <div v-if="isAdminManage">
            <div class="toggle-block__details-bottom"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['fbm_CalculatePrice',])"></div>
              <MainButton
                  class="wfc"
                  :value="$t('fbm_CalculatePrice.localization_value.value')"
                  @click.native="$emit('calculatePriceAdmin')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="toggle-block__details-body" v-if="!FBM.data.shippingPartnerType">
      <div class="custom-col mb-2" v-if="getIncotermList && Object.keys(getIncotermList).length">
        <DefaultSelect
            :options="Object.values(getIncotermList)"
            :label="$t('express_ddp.localization_value.value')"
            :otherValue="''"
            v-bind:class="{'ui-no-valid': FBM.validation.incoterm}"
            :errorTxt="$t(`${FBM.validationTranslate.incoterm}.localization_value.value`)"
            :error="FBM.validation.incoterm"
            :selected="FBM.data.incoterm"
            :clearable="false"
            @change="(val) => {FBM.data.incoterm = val; $emit('calculatePopular')}"
        />
<!--            @change="(val) => {FBM.data.incoterm = val; isAdmin ?  $emit('calculatePriceAdmin') : $emit('calculatePriceUser')}"-->
      </div>

      <div class="custom-row">
        <div class="custom-col flex-column-reverse mb-2" >
          <template
              v-for="(popularMethod, index) in FBM.data.popularMethodsTypeArray">
<!--                :class="{'mb3': getDutyAndVat(popularMethod)}"-->
            <RadioDefault
                class="mb-4 w-auto"
                name="fedexRadioList1"
                :key="index + 'shippingPartner'"
                :label="shippingPriceRadioLabel(popularMethod)"
                :helpText="getDutyAndVat(popularMethod)"
                :value="FBM.data.popularMethodSelected ? popularMethod.delivery_method_id === FBM.data.popularMethodSelected.delivery_method_id : false"
                :cardFlex="true"
                @mouseup.native="FBM.data.popularMethodSelected = popularMethod"
            >
            </RadioDefault>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadioDefault from "@/components/UI/radiobuttons/RadioDefault/RadioDefault";
import DefaultCheckbox from "@/components/UI/checkboxes/DefaultCheckbox/DefaultCheckbox";
import MainButton from "@/components/UI/buttons/MainButton/MainButton";
import {FBMMixins} from "@/mixins/FBMMixins/FBMMixins";
import {FBM_SHIPPING_TYPES} from "@/staticData/staticVariables";
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";

export default {
  name: "ShippingRates",

  components: {DefaultSelect, MainButton, DefaultCheckbox, RadioDefault},

  mixins: [FBMMixins],

  props: {
    FBM: Object,
    // getShippingPartner: Object,
    shippingCompanyData: Array,
    isAdminManage: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    getShippingPartner(){
      let partner = this._.find(this.shippingCompanyData, {delivery_company_id: this.FBM.data.shippingPartnerType?.delivery_company_id})

      if(!partner) {
        partner = this._.first(this.shippingCompanyData)
      }
      return partner
    },

    getIncotermList() {
      console.log(this._.find(this.shippingCompanyData, item => item?.incoterm_list?.DDP)?.incoterm_list);
      // return this._.find(this.shippingCompanyData, 'incoterm_list')?.incoterm_list
      return this._.find(this.shippingCompanyData, item => item?.incoterm_list?.DDP)?.incoterm_list
    }
  },

  data() {
    return {
      FBM_SHIPPING_TYPES: FBM_SHIPPING_TYPES,
    }
  },

  methods: {
    getDutyAndVat(itemShippingAPIPrices) {
      let text = ''

      if(Number(itemShippingAPIPrices.country_duty_value) > 0 || Number(itemShippingAPIPrices.hscode_duty_value) > 0) {
        text += this.$t('fbm_Includes.localization_value.value') + ' ' + this.$t('fbm_Duty.localization_value.value') + ' $' +
            itemShippingAPIPrices.country_duty_value + ' ' +
          '(' + parseFloat(itemShippingAPIPrices.country_duty_percent).toFixed(0) + '%) & $' + itemShippingAPIPrices.hscode_duty_value + ' (% HS)'
      }

      if(Number(itemShippingAPIPrices?.duty_detail?.brokerage_fee) > 0) {
        if(text.length > 0) text += ' &'
        text += ' ' + itemShippingAPIPrices?.duty_detail?.brokerage_fee + ' ' + this.$t('express_brokerage.localization_value.value')
      }

      if(Number(itemShippingAPIPrices.vat_value) > 0) {
        if(text.length > 0) text += ' &'
        text += ' ' + itemShippingAPIPrices.vat_value + ' ' + 'VAT'
      }

      if(Number(itemShippingAPIPrices?.duty_detail?.line_item_extra_fee) > 0) {
        text += ' $' + itemShippingAPIPrices?.duty_detail?.line_item_extra_fee + ' ' + this.$t('express_LineItem.localization_value.value')
      }

      if(Number(itemShippingAPIPrices?.duty_detail?.euro_vat_rate) > 0) {
        text += ' $' + itemShippingAPIPrices?.duty_detail?.euro_vat_rate + ' ' + 'EU Vat'
      }

      return text.length === 0 ? null : text
    },

    shippingPriceRadioLabel(itemShippingAPIPrices) {
      let label = itemShippingAPIPrices.name + ' $' + itemShippingAPIPrices.shipmentCost + ' ' +
          `${itemShippingAPIPrices.warning_message ? itemShippingAPIPrices.warning_message : ''}`
      if(parseFloat(itemShippingAPIPrices.insuranceCost) > 0){
        label += ' insurance $' + itemShippingAPIPrices.insuranceCost
      }
      return label
    },
  }

}
</script>

<style scoped>

</style>